// src/pages/LoginPassword.js
import React, { useState } from 'react';
import { Form, Button, Container, Card } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { login } from '../redux/actions/authActions';
import { useLocation, useNavigate } from 'react-router-dom';

function LoginPassword() {
  const [password, setPassword] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || '';

  const handleSubmit = async (e) => {
    e.preventDefault();
    const success = await dispatch(login(email, password));
    if (success) {
      navigate('/');
    }
    // On failure, a generic error toast will be shown
  };

  return (
    <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
      <Card style={{ width: '400px' }}>
        <Card.Body>
          <Card.Title>Login - Step 2: Password</Card.Title>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control type="email" value={email} readOnly />
            </Form.Group>
            <Form.Group controlId="formPassword" className="mt-3">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </Form.Group>
            <Button variant="primary" type="submit" className="mt-3" block>
              Login
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default LoginPassword;
